import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { ActionSheetContent } from '@/components/action-sheet';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { ListOption } from '@/components/list-item';
import { PaymentMethodOption } from '@/contexts/payments-context';

export type PaymentMethodListOption = ListOption<PaymentMethodOption>;

interface Props {
  onCancel: () => void;
  onDelete: () => Promise<void>;
  selectedPaymentMethod: PaymentMethodListOption | null;
}

export const DeletePaymentActionSheet: React.FC<Props> = ({
  onCancel,
  onDelete,
  selectedPaymentMethod,
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <BaseActionSheet
      isVisible={Boolean(selectedPaymentMethod)}
      onClose={onCancel}
    >
      <ActionSheetContent
        actions={[i18n.t('delete'), i18n.t('cancel')]}
        loadingActionIndex={loading ? 0 : undefined}
        message={i18n.t('delete_payment_confirmation.message', {
          paymentTitle: selectedPaymentMethod?.title,
        })}
        onAction={async (_, idx) => {
          if (idx === 0) {
            setLoading(true);
            await onDelete();
            setLoading(false);
          } else {
            onCancel();
          }
        }}
        title={i18n.t('delete_payment_confirmation.title')}
      />
    </BaseActionSheet>
  );
};
